module.exports = __webpack_public_path__ + "static/media/Hire_Form_logo.ad556b04.svg";